module.exports = __webpack_public_path__ + "img/ic_time.34f02413.svg";